import React, { useState } from 'react';
import { Button, Tabs, Tab, ModalWrapper } from 'carbon-components-react';

import { infoSection } from './LandingPageUtilities';

const props = {
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

const LandingPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div
      className="bx--grid bx--grid--full-width landing-page"
      style={{
        // backgroundImage: `url(${process.env.PUBLIC_URL}/unsplash-Ramon-salinero.jpg)`,
        backgroundImage: `url(${process.env.PUBLIC_URL}/3-2.jpg)`,
      }}>
      <div className="bx--row landing-page__banner">
        <div className="bx--col-lg-16">
          <h1 className="landing-page__heading">
            <strong>CIRCA </strong>| Where Discovery Begins
          </h1>
        </div>
      </div>
      <div className="bx--row landing-page__r2" style={{ color: '#ffffff' }}>
        <div className="bx--col bx--no-gutter">
          <Tabs {...props.tabs} aria-label="Tab navigation">
            <Tab
              {...props.tab}
              label="Overview"
              onClick={() => setActiveTab('overview')}>
              <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
                <div className="bx--row landing-page__tab-content">
                  <div
                    style={{
                      height: 'fit-content',
                      minHeight: '40vh',
                      marginBottom: '0.0rem',
                    }}>
                    <h2 className="landing-page__subheading">What is CIRCA?</h2>
                    <p
                      className="landing-page__p"
                      style={{
                        minWidth: '290px',
                        maxWidth: '450px',
                        width: 'auto',
                      }}>
                      CIRCA is an IBM Research platform designed to advance
                      scientific exploration and discovery in the areas of
                      chemistry, biology and materials. CIRCA enables easy
                      search, visualization, and flexible export options of
                      chemically-annotated data from publicly available patents
                      and other data sources.
                    </p>

                    <a
                      href="https://circa.res.ibm.com/circa/articleSearch.jsp"
                      style={{ marginRight: '30px', textDecoration: 'none' }}>
                      <Button>Login by IBMid</Button>
                    </a>

                    <ModalWrapper
                      className="LandingPage-modal"
                      passiveModal
                      buttonTriggerClassName="LandingPage-modal-trigger-button"
                      buttonTriggerText="Get Access"
                      triggerButtonKind="secondary">
                      <div className="LandingPage-modal-title">CONTACT US!</div>
                      <div className="LandingPage-modal-title-label">
                        CIRCA - Chemical Information Resources for Cognitive
                        Analytics
                      </div>
                      <div className="LandingPage-modal-text">
                        <p>
                          Thank you for your interest in IBM CIRCA! To request
                          access or to get in contact with the team, please send
                          us your inquiry by email and we will get back to you
                          shortly!
                        </p>
                        <p className="LandingPage-modal-email">
                          <a href="mailto:circa@us.ibm.com">circa@us.ibm.com</a>
                        </p>
                      </div>
                    </ModalWrapper>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              {...props.tab}
              label="Efficacy"
              onClick={() => setActiveTab('efficacy')}>
              <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
                <div className="bx--row landing-page__tab-content">
                  <div style={{ height: 'fit-content', minHeight: '40vh' }}>
                    <h2 className="landing-page__subheading">Efficacy.</h2>
                    <p
                      className="landing-page__p"
                      style={{
                        minWidth: '290px',
                        maxWidth: '450px',
                        width: 'auto',
                      }}>
                      CIRCA offers unique capabilities to make searches and
                      exploration in the chemical and biological space more
                      efficient. It provides the cognitive and big data
                      infrastructure together with linkages to complementary IBM
                      tools to enable advanced AI solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab
              {...props.tab}
              label="Complexity"
              onClick={() => setActiveTab('complexity')}>
              <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
                <div className="bx--row landing-page__tab-content">
                  <div style={{ height: 'fit-content', minHeight: '40vh' }}>
                    <h2 className="landing-page__subheading">Complexity.</h2>
                    <p
                      className="landing-page__p"
                      style={{
                        minWidth: '290px',
                        maxWidth: '414px',
                        width: 'auto',
                      }}>
                      CIRCA covers a large scientific and technical data corpus
                      which is derived from patents, abstracts, and full text
                      articles, along with public databases. Each document was
                      annotated to extract for chemical and biologic specific
                      entities.
                    </p>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
      <div style={{ marginBottom: '2.5rem' }}>{infoSection[activeTab]}</div>
    </div>
  );
};

export default LandingPage;
